module.exports = __webpack_public_path__ + "img/bg-ranking.5cf5292c.png";